import React, { useContext, useEffect, useState } from "react";
import { HeaderComponent, Sidebar } from "../components";
import { useLocation } from "react-router-dom";
import { Store } from "../context/Store/Store";
import { useWeb3ModalAccount } from "@web3modal/ethers5/react";
import { ethers } from "ethers";

const ClaimHistory = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { getUserEventsHistory, userHistoryData } = useContext(Store);
  const { address, chainId, isConnected } = useWeb3ModalAccount();
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    getUserEventsHistory();
  }, [address]);

  return (
    <>
      <div style={{ display: "flex" }} className="backOffice">
        {/* Sidebar */}
        <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

        {/* Main Content Area */}
        <div
          style={{
            // marginLeft: isSidebarOpen ? "250px" : "80px",
            width: "100%",
            transition: "margin-left 0.3s ease",
          }}
          className="sidebarWidthDeafult"

        >
          <HeaderComponent isSidebarOpen={isSidebarOpen} />

          <div className="content">
            <div style={{ padding: "20px", paddingTop: "100px" }}>
              <div className="breadcrum">
                <div className="table-wrapper">
                  <table>
                    <thead>
                      {/* <th>Username</th> */}
                      {/* <th>Email</th> */}
                      {/* <th>Phone</th> */}
                      <th>Address</th>
                      <th></th>
                      <th>Claim Amount</th>
                      <th>Date</th>
                      <th>type</th>
                    </thead>
                    <tbody>
                      {userHistoryData?.claimHistory?.length > 0 ? (
                        userHistoryData?.claimHistory?.map((row, index) => (
                          <tr key={index}>
                            {/* Displaying username */}
                            <td>
                              {`${row?.user_address?.slice(
                                0,
                                6
                              )}....${row?.user_address?.slice(-6)}` || "N/A"}
                            </td>
                            <td></td>
                            {/* Displaying buy amount */}
                            <td>{row?.tokenAmount || "0"}</td>

                            {/* Displaying date */}
                            <td>
                              {new Date(row?.createdAt).toLocaleDateString() ||
                                "N/A"}
                            </td>
                            {/* Displaying date */}
                            <td>{row?.eventType}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" style={{ textAlign: "center" }}>
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClaimHistory;
